import { createContext, useState } from 'react';

interface IExcelPresentationTableProvider {
  children: React.ReactNode;
}

interface IExcelPresentationTableContext {
  setTableFilterRecordFn: (...args: any) => void;
  tableFilterRecord?: Map<string, Map<string, any>>;
}

export const ExcelPresentationTableContext =
  createContext<IExcelPresentationTableContext | null>(null);

export const ExcelPresentationTableProvider: React.FC<
  IExcelPresentationTableProvider
> = ({ children }) => {
  const [tableFilterRecord, setTableFilterRecord] =
    useState<Map<string, Map<string, any>>>();

  const setTableFilterRecordFn = (tableData: Map<string, Map<string, any>>) => {
    setTableFilterRecord(tableData);
  };

  return (
    <ExcelPresentationTableContext.Provider
      value={{
        setTableFilterRecordFn,
        tableFilterRecord,
      }}
    >
      {children}
    </ExcelPresentationTableContext.Provider>
  );
};
